var exports = {
  "g": "OmnibarContainer__S1PaVE",
};

module.exports = exports;
